// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6QKGO","content":"styles_content__rKjMz"};